/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Weird_Martin_AimInputs */

const fr_glad_weird_martin_aim = /** @type {(inputs: Glad_Weird_Martin_AimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme`)
};

/**

* @param {Glad_Weird_Martin_AimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const glad_weird_martin_aim = /** @type {((inputs?: Glad_Weird_Martin_AimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Weird_Martin_AimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_glad_weird_martin_aim(inputs)
});